import { AskHelpInput, AskHelpOutput } from '@allocab/allocab-passenger-shared-types';
// eslint-disable-next-line import/named
import { useMutation } from '@tanstack/react-query';
import jwtDecode from 'jwt-decode';

import { queryKeys } from '../services/datastore/queryKeys';
import { passengerApi } from '../services/network/Api';
import { AnonymousTokenData } from '../utils/common';

type Input = AskHelpInput & { jwtToken: string };

const fetchAnonymousHelp = ({ jwtToken, ...input }: Input) =>
  passengerApi.get<AskHelpInput, AskHelpOutput>('/anonymous/v1/trip/help', input, {
    headers: { Authorization: `Bearer ${jwtToken}` },
  });

const useFetchAnonymousHelp = (jwtToken: string) => {
  const tokenData = jwtDecode(jwtToken) as AnonymousTokenData;

  const fetchAnonymousHelpMutation = useMutation(queryKeys.fetchAnonymousHelp(jwtToken), () =>
    fetchAnonymousHelp({ key: tokenData.fareEncodedKey, jwtToken }),
  );

  return fetchAnonymousHelpMutation;
};

export default useFetchAnonymousHelp;
